/**
 * contactIdentity.js — Identité d'un contact : source de vérité UNIQUE.
 *
 * Règle produit (iter114) : une personne morale s'affiche de la même façon partout
 * (liste, fiche contact, fiche bien, recherche globale) — « Jean DUPONT — SARL EXEMPLE ».
 * La société ne remplace JAMAIS le nom de la personne, et inversement.
 *
 * Stockages historiques couverts : nom_societe (canonique), societe, raison_sociale, enseigne.
 */

export const getContactSociete = (c) => {
  if (!c) return '';
  return (c.nom_societe || c.societe || c.raison_sociale || c.enseigne || '').toString().trim();
};

export const getContactPersonName = (c) => {
  if (!c) return '';
  return `${c.prenom || ''} ${c.nom || ''}`.replace(/\s+/g, ' ').trim();
};

/** « Jean DUPONT — SARL EXEMPLE » (ou l'un des deux si l'autre est vide). */
export const getContactFullLabel = (c) => {
  const person = getContactPersonName(c);
  const societe = getContactSociete(c);
  if (person && societe && person.toLowerCase() !== societe.toLowerCase()) return `${person} — ${societe}`;
  return person || societe || 'Sans nom';
};

/** Normalisation pour la recherche : minuscules, sans accents. */
export const normalizeSearch = (s) =>
  (s === null || s === undefined ? '' : String(s))
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();

const digitsOf = (s) => (s || '').toString().replace(/\D/g, '');

/**
 * Un contact matche-t-il la requête ? Couvre nom, prénom, société (tous stockages),
 * référence, TOUS les emails, TOUS les téléphones (formats +33 6 10… et 0610…), ville.
 */
export const contactMatchesQuery = (contact, rawQuery) => {
  const q = normalizeSearch(rawQuery).trim();
  if (!q) return true;
  const c = contact || {};
  const haystack = [
    c.nom,
    c.prenom,
    getContactSociete(c),
    c.reference,
    c.ville,
    c.profession,
    c.email,
    c.telephone,
    ...(c.emails || []).map((e) => (typeof e === 'string' ? e : e?.email)),
    ...(c.telephones || []).map((t) => (typeof t === 'string' ? t : t?.numero)),
  ]
    .filter(Boolean)
    .map(normalizeSearch);

  if (haystack.some((h) => h.includes(q))) return true;

  // Téléphone : comparaison sur les chiffres uniquement (+33 6 10 69 09 80 ↔ 0610690980)
  const qDigits = digitsOf(rawQuery);
  if (qDigits.length >= 4) {
    const phones = [
      c.telephone,
      c.telephone_pro,
      ...(c.telephones || []).map((t) => (typeof t === 'string' ? t : t?.numero)),
    ]
      .filter(Boolean)
      .map(digitsOf);
    const tail = qDigits.slice(-9);
    if (phones.some((p) => p.endsWith(tail) || p.includes(tail))) return true;
  }
  return false;
};
